import { render, staticRenderFns } from "./Latitude.vue?vue&type=template&id=65d396e3&lang=pug"
import script from "./Latitude.vue?vue&type=script&lang=js"
export * from "./Latitude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports